<script setup lang="ts">
import { VForm } from 'vuetify/components/VForm'
import UserPasswordEditDialog from '@/components/dialogs/UserPasswordEditDialog.vue'


definePage({
  meta: {
    layout: 'blank',
    unauthenticatedOnly: true,
  },
})

const form = ref({
  compNo: useStorage('compNo').value,
  username: '',
  password: '',
  remember: false,
})


const isPasswordVisible = ref(false)
const route = useRoute('reset-passwd')
const router = useRouter()

const provider = route.query.provider
const userNo = route.query.userId

const isPrivacyDialogVisible = ref(true)
const isDialogVisible = ref(false)
const hasClickedPolicy = ref(false)

const proceedToPasswordDialog = () => {
  isPrivacyDialogVisible.value = false
  isDialogVisible.value = true
}

const onPolicyClicked = () => {
  hasClickedPolicy.value = true
}

const policyLink = ref('')

// 當密碼修改完成後回傳
const updateUserPassword =  async (updateData: any) => {
  const res = await $api('/du/user/password/updatePassword', {
    method: 'PUT',
    body: {
      userNo: updateData.userNo,
      oldPwd: updateData.password,
      newPwd: updateData.newPassword,
      newPwdCheck: updateData.confirmPassword
    },
    onResponse(context) {
      if (context.response.status === 200) {
        $swal({
          position: 'top-end',
          icon: 'success',
          title: '密碼變更完成',
          showConfirmButton: false,
          timer: 1500,
          customClass: {
            confirmButton: 'btn btn-primary',
          },
          buttonsStyling: false,
        }).then(() => {
          location.href = "/login?oauthLogin=Y&provider="+provider;
        })
      }
    },
    onResponseError({ response }) {
      $swal({
        position: 'top-end',
        icon: 'error',
        title: '密碼變更失敗',
        showConfirmButton: false,
        timer: 1500,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        buttonsStyling: false,
      }).then(() => {
        isDialogVisible.value = true;
      })
    },
  })
}

const ability = useAbility()

if(userNo===''){
  location.href = '/'
}

const errors = ref<Record<string, string | undefined>>({
  userId: undefined,
  password: undefined,
})


onMounted(() => {

  $api('/orp/api/privacyPolicy', {
    method: 'GET',
    onResponseError({ response }) {
      console.error('error.', response)
    }
  }).then((data)=>{
    policyLink.value  = data.link
  })
});

</script>

<template>
  <div class="pa-6">
    <VDialog v-model="isPrivacyDialogVisible" max-width="500" persistent>
      <VCard>
        <VCardTitle class="text-h6 font-weight-bold">隱私權政策</VCardTitle>

        <VCardText>
          <p class="mb-4">
            為保障您的帳號安全，請確認您已閱讀並同意我們的
            <a
              :href="policyLink"
              target="_blank"
              class="text-primary font-weight-bold"
              @click="onPolicyClicked"
            >
              隱私權政策
            </a>
            與使用條款。
          </p>

          <p class="text-body-2 text-muted mb-0">
            ※ 點選「隱私權政策」後，才能啟用「我同意」按鈕。
          </p>
        </VCardText>

        <VCardActions class="justify-center pb-6">
          <VBtn
            color="primary"
            variant="tonal"
            size="large"
            :disabled="!hasClickedPolicy"
            @click="proceedToPasswordDialog"
          >
            我同意
          </VBtn>
        </VCardActions>
      </VCard>
    </VDialog>
    <user-password-edit-dialog
      v-model:isDialogVisible="isDialogVisible"
      :user-no="userNo"
      :persistent="true"
      @updateUserPassword="updateUserPassword"
    />
  </div>
</template>


    <style>
        body {
            margin: 0;
            padding: 0;
            font-family: sans-serif;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 100vh;
            background: #f5f5f5;
        }

        .loader {
            border: 6px solid #eee;
            border-top: 6px solid #3498db;
            border-radius: 50%;
            width: 50px;
            height: 50px;
            animation: spin 1s linear infinite;
            margin-bottom: 20px;
        }

        @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }

        .text {
            font-size: 18px;
            color: #555;
        }
    </style>

<style lang="scss">
@use "@core/scss/template/pages/page-auth.scss";
</style>
